/**
 * Selbstzahler-Preise für eine MRT-Untersuchung – gemeinsame Quelle für alle
 * Ratgeber.
 *
 * Die Angaben standen vorher je Artikel getrennt und widersprachen sich
 * („200 bis über 1.000 Euro" gegen „280 bis 600 Euro"), obwohl beide Seiten an
 * genau dieser Stelle aufeinander verlinken. Grundlage ist die Gebührenordnung
 * für Ärzte (GOÄ); die Spannen decken die übliche Steigerungssatz-Bandbreite ab.
 */

/** Standardfall: eine Körperregion, ohne Kontrastmittel. */
export const SELF_PAY_STANDARD = '280 bis 600 Euro';

/** Kurzform für Tabellenzellen. */
export const SELF_PAY_STANDARD_SHORT = 'ca. 280–600 €';

/** Mehrere Regionen, Kontrastmittel oder Spezialuntersuchungen (Prostata, Herz). */
export const SELF_PAY_COMPLEX = 'über 1.000 Euro';

/** Ganzkörper-MRT als Vorsorgeleistung. */
export const SELF_PAY_WHOLE_BODY = '1.000 bis 2.000 Euro';

/** Herz-MRT (Kardio-MRT) als Selbstzahler – je nach Umfang, Stress-Untersuchung und Kontrastmittel. */
export const SELF_PAY_CARDIAC = '500 bis 1.200 Euro';
